import Home from '../components/pages/home/Home'
import NotFound from '../components/pages/404/NotFound'
import Login from '../components/pages/login/Login'
import Recover from '../components/pages/forgotpassword/Recover'
import Reset from '../components/pages/forgotpassword/Reset'
import Register from '../components/pages/register/Register'
import UpdatePass from '../components/pages/updatepass/UpdatePass'
import Profile from '../components/pages/profile/Profile'
import Users from '../components/pages/users/Users'
import ServerConfig from '../components/pages/server-config/ServerConfig'
import DataWarehouse from '../components/pages/data-warehouse/DataWarehouse'
import corporations from '../components/pages/corporations/Corporations'
import CloverMermaSummary from '../components/pages/summarywindows/CloverMermaSummary'
import Comparisons from '../components/pages/comparisons/Comparisons'
import TaxComparison from '../components/pages/comparisons/TaxComparison'
import CategoryComparison from '../components/pages/comparisons/CategoryComparison'
import CloverSalesSummary from '../components/pages/summarywindows/CloverSalesSummary'
import MergedSalesAndMermaDailySummary from '../components/pages/summarywindows/MergedSalesAndMermaDailySummary'
import MergedSalesDailySummary from '../components/pages/summarywindows/MergedSalesDailySummary'
import MergedSalesWeeklySummary from '../components/pages/summarywindows/MergedSalesWeeklySummary'
import AnalyticsMargin from '../components/pages/analytics/AnalyticsMargin'
import AnalyticsShrinkage from '../components/pages/analytics/AnalyticsShrinkage'
import AnalyticsStores from '../components/pages/analytics/AnalyticsStores'
import AnalyticsTender from '../components/pages/analytics/AnalyticsTender'
import AnalyticsTraffic from '../components/pages/analytics/AnalyticsTraffic'
import AnalyticsQuality from '../components/pages/analytics/AnalyticsQuality'

const routes = [
    {
      id: 'login',
      name: 'login',
      path: '/',
      exact: true,
      protected: false,
      component: Login,
    },
    {
      id: 'recover',
      name: 'recover',
      path: '/recover',
      exact: true,
      protected: false,
      component: Recover,
    },
    {
      id: 'corporations',
      name: 'corporations',
      path: '/corporations',
      exact: true,
      protected: false,
      component: corporations,
    },
    {
      id: 'reset',
      name: 'reset',
      path: '/reset/:id/:token',
      exact: true,
      protected: false,
      component: Reset,
    },
    {
      id: 'register',
      name: 'register',
      path: '/register',
      exact: true,
      protected: false,
      component: Register,
    },
    {
      id: 'home',
      name: 'home',
      path: '/home',
      exact: true,
      protected: false,
      component: Home,
    },
    {
      id: 'profile',
      name: 'profile',
      path: '/profile',
      exact: true,
      protected: false,
      component: Profile,
    },
    {
      id: 'serverconfig',
      name: 'serverconfig',
      path: '/serverconfig',
      exact: true,
      protected: false,
      component: ServerConfig,
    },
    {
      id: 'datawarehouse',
      name: 'datawarehouse',
      path: '/datawarehouse',
      exact: true,
      protected: false,
      component: DataWarehouse,
    },
    {
      id: 'users',
      name: 'users',
      path: '/users',
      exact: true,
      protected: false,
      component: Users,
    },
    {
      id: 'updatepass',
      name: 'updatepass',
      path: '/updatepass',
      exact: true,
      protected: false,
      component: UpdatePass,
    },
    {
      id: 'clovermermasummarywindow',
      name: 'clovermermasummarywindow',
      path: '/summary/salesshirkage/clover',
      exact: true,
      protected: false,
      component: CloverMermaSummary,
    },
    {
      id: 'clovermermasummary',
      name: 'clovermermasummary',
      path: '/summary/sales/clover',
      exact: true,
      protected: false,
      component: CloverSalesSummary,
    },
    {
      id: 'salesshirkagesummary',
      name: 'salesmermasummary',
      path: '/summary/salesshirkage',
      exact: true,
      protected: false,
      component: MergedSalesAndMermaDailySummary,
    },
    {
      id: 'salesdailysummary',
      name: 'salesdailysummary',
      path: '/summary/sales/daily',
      exact: true,
      protected: false,
      component: MergedSalesDailySummary,
    },
    {
      id: 'salesweeklysummary',
      name: 'salesweeklysummary',
      path: '/summary/sales/weekly',
      exact: true,
      protected: false,
      component: MergedSalesWeeklySummary,
    },
    {
      id: 'comparisons',
      name: 'comparisons',
      path: '/comparisons',
      exact: true,
      protected: false,
      component: Comparisons,
    },
    {
      id: 'tax-comparison',
      name: 'tax-comparison',
      path: '/taxcomparison',
      exact: true,
      protected: false,
      component: TaxComparison,
    },
    {
      id: 'category-comparison',
      name: 'category-comparison',
      path: '/categorycomparison',
      exact: true,
      protected: false,
      component: CategoryComparison,
    },
    {
      id: 'analytics-margin',
      name: 'analytics-margin',
      path: '/analytics/margin',
      exact: true,
      protected: false,
      component: AnalyticsMargin,
    },
    {
      id: 'analytics-shrinkage',
      name: 'analytics-shrinkage',
      path: '/analytics/shrinkage',
      exact: true,
      protected: false,
      component: AnalyticsShrinkage,
    },
    {
      id: 'analytics-stores',
      name: 'analytics-stores',
      path: '/analytics/stores',
      exact: true,
      protected: false,
      component: AnalyticsStores,
    },
    {
      id: 'analytics-tender',
      name: 'analytics-tender',
      path: '/analytics/tender',
      exact: true,
      protected: false,
      component: AnalyticsTender,
    },
    {
      id: 'analytics-traffic',
      name: 'analytics-traffic',
      path: '/analytics/traffic',
      exact: true,
      protected: false,
      component: AnalyticsTraffic,
    },
    {
      id: 'analytics-quality',
      name: 'analytics-quality',
      path: '/analytics/quality',
      exact: true,
      protected: false,
      component: AnalyticsQuality,
    },
    /* Error route */
    {
      id: '404',
      name: 'Not Found',
      path: '*',
      exact: true,
      protected: false,
      component: NotFound,
    },
]; 

export default routes;
